import {
  ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_WORKED_LABEL,
  buildAcmeInsuranceRenewalMondayTriggerBlocks,
} from '../demo/acmeInsuranceRenewalDemoContent.part03.js'
import { scaleChatStreamDelay } from '../streaming/chatStreamSpeed.js'
import { updatePendingAcmeInsuranceRenewalDemoMessage } from './patchAcmeInsuranceRenewalDemoMessage.js'
import {
  runSyntheticDataDemoTypewriter,
  SYNTHETIC_DEMO_TYPEWRITER_OPTIONS,
  syntheticDemoTypewriterDurationMs,
} from './syntheticDataDemoTypewriter.js'

/** @param {import('./runB2bCopilotPlanDemoStream.js').B2bStreamCtx} ctx */
export function startAcmeInsuranceRenewalMondayTriggerStreamLoop(ctx) {
  const { tid, pendingId, signal, session, setMessagesByThreadId } = ctx
  const state = { blocks: /** @type {object[]} */ ([]) }

  const patch = (fields) => updatePendingAcmeInsuranceRenewalDemoMessage(setMessagesByThreadId, tid, pendingId, fields)
  const schedule = (ms, fn) => {
    session.addTimeout(() => {
      if (signal.aborted) {
        session.dispose()
        return
      }
      fn()
    }, ms)
  }
  const runAfter = (ms, fn) => schedule(scaleChatStreamDelay(ms), fn)
  const runTypewriterText = (text, onUpdate, onDone) => {
    runSyntheticDataDemoTypewriter({ session, signal, text, onUpdate, onDone })
  }

  const runMarkdownType = (content, onDone) => {
    const blockIndex = state.blocks.length
    state.blocks.push({ type: 'markdown', content: '' })
    patch({ blocks: [...state.blocks] })
    runTypewriterText(
      content,
      (partial) => {
        state.blocks[blockIndex] = { type: 'markdown', content: partial }
        patch({ blocks: [...state.blocks] })
      },
      onDone,
    )
  }

  const runBlocks = (onDone) => {
    const templates = buildAcmeInsuranceRenewalMondayTriggerBlocks()
    let blockIdx = 0

    const runNext = () => {
      if (blockIdx >= templates.length) {
        onDone()
        return
      }

      const block = templates[blockIdx]
      blockIdx++

      if (block.type === 'createdTrigger') {
        state.blocks.push({
          type: 'createdTrigger',
          title: block.title,
          schedule: block.schedule,
          label: block.label,
        })
        patch({ blocks: [...state.blocks] })
        runAfter(120, runNext)
        return
      }

      if (block.type === 'markdown') {
        runMarkdownType(block.content, () => runAfter(75, runNext))
        return
      }

      runNext()
    }

    runNext()
  }

  patch({
    demoStreamActive: true,
    text: '',
    thoughtSummary: 'Thinking…',
    thoughtDetails: [],
    blocks: [],
    agentBrand: 'SIA',
    agentName: 'Master Root Agent',
  })

  runAfter(280, () => {
    runBlocks(() => {
      patch({
        demoStreamActive: false,
        text: '',
        thoughtSummary: ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_WORKED_LABEL,
        acmeInsuranceRenewalAwaitingMondayTrigger: false,
        acmeInsuranceRenewalMondayTriggerCompleted: true,
        blocks: [...state.blocks],
      })
      session.dispose()
    })
  })
}
